import React from 'react';
import { BsInstagram } from "react-icons/bs";
import {FaLinkedin} from "react-icons/fa"
import {FiTwitter} from "react-icons/fi"
import '../css/footer.css'

const Footer = () => {
    return (
        <footer className='footer'>
            <div  className='footer-title'>RemoteWorld </div>
            <div className='footer-links'>
                <a href='https://www.linkedin.com/in/isaac-kabucho' target= '_blank' rel="noreferrer"><FaLinkedin/></a>
                <a href='https://twitter.com/KabuchoIsaac'  target= '_blank' rel="noreferrer"><FiTwitter/></a>
                <a href='#'><BsInstagram/></a>
            </div>
        </footer>
    );
};

export default Footer;